<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Allgemeine Einstellungen - {{ brand_name }}</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newSettingForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="col-md-10 form-div">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group id="fieldset-horizontal">
                    <ValidationProvider
                      rules="priceInput"
                      v-slot="{ errors }"
                      :custom-messages="{
                        min_value:
                          'Die Standard Mehrwertsteuersatz (%) muss mindestens 0 betragen',
                      }"
                    >
                      <v-text-field
                        :error-messages="errors[0]"
                        autocomplete="new-password"
                        v-model="form.tax"
                        label="Standard Mehrwertsteuersatz (%)"
                        outlined
                      ></v-text-field>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="fieldset-horizontal">
                    <ValidationProvider
                      rules="required|priceInput"
                      v-slot="{ errors }"
                      :custom-messages="{
                        required: 'This is required',
                        min_value: 'Der Mindestbestellwert muss 0 oder größer sein',
                      }"
                    >
                      <v-text-field
                        :error-messages="errors[0]"
                        autocomplete="new-password"
                        v-model="form.minOrderValue"
                        label="Mindestbestellwert (€)"
                        outlined
                        clearable
                      ></v-text-field>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <v-divider></v-divider>
                  <span> Diese Provision wird auf alle Bestellungen angewendet </span>
                  <b-form-group class="mt-5">
                    <ValidationProvider
                      rules="priceInput"
                      v-slot="{ errors }"
                      :custom-messages="{
                        required: 'This is required.',
                      }"
                    >
                      <v-text-field
                        :error-messages="errors[0]"
                        autocomplete="new-password"
                        v-model="form.commission"
                        label="Provision (%)"
                        outlined
                        readonly
                      ></v-text-field>
                    </ValidationProvider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <v-divider></v-divider>
                  <v-checkbox
                    v-model="form.vatSettingChk"
                    label="Umsatzsteuerfrei aufgrund der Kleinunternehmerregelung"
                  ></v-checkbox>
                </div>
              </div>
              <v-divider></v-divider>
              <!-- Shipping conditions -->
              <div class="row">
                <h3>Warenübergabe:</h3>
                <div class="col-md-12">
                  <v-checkbox
                    class="my-5"
                    v-model="isPickupService"
                    label="Kunde kann die Ware persönlich abholen"
                  ></v-checkbox>
                  <v-checkbox
                    class="my-5"
                    v-model="isParcelService"
                    label="Lieferung durch einen Paketdienst"
                  ></v-checkbox>
                  <span class="text-danger" v-if="isAdded"
                    >Wählen Sie mindestens eine Option aus</span
                  >
                </div>
              </div>
              <div v-if="isParcelService">
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-12">
                    <!-- <v-container fluid> -->
                    <v-radio-group v-model="form.transportCostOption">
                      <template v-slot:label>
                        <div>Lieferspesen-Optionen (nur eine auswählbar)</div>
                      </template>
                      <v-radio value="free">
                        <template v-slot:label>
                          <div>versandkostenfrei</div>
                        </template>
                      </v-radio>
                      <v-radio value="amount">
                        <template v-slot:label>
                          <div>Lieferspesen abhängig vom Gesamtbestellwert (€)</div>
                        </template>
                      </v-radio>
                      <div v-if="form.transportCostOption === 'amount'">
                        <div class="col-md-6">
                          <ValidationProvider
                            rules="priceInput"
                            v-slot="{ errors }"
                            :custom-messages="{
                              required: 'This is required',
                            }"
                          >
                            <v-text-field
                              autocomplete="new-password"
                              v-model="form.free_deilvery_from"
                              :error-messages="errors[0]"
                              label="Gratislieferung ab (€)"
                              outlined
                              clearable
                            ></v-text-field>
                          </ValidationProvider>
                        </div>
                        <v-divider></v-divider>
                        <div
                          class="row mt-5"
                          v-for="(cost, i) in transportEuro"
                          :key="'crf' + i"
                        >
                          <div class="col-md-5">
                            <ValidationProvider
                              rules="required|priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                autocomplete="new-password"
                                v-model="cost.order_cost"
                                :error-messages="errors[0]"
                                label="Bestellwert bis (€)"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                          <div class="col-md-5">
                            <ValidationProvider
                              rules="required|priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                autocomplete="new-password"
                                v-model="cost.transport_cost"
                                :error-messages="errors[0]"
                                label="Lieferspesen (€)"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                          <div class="col-md-2">
                            <a v-if="i > 0" @click="removeTransportEuroCost(i,cost)"
                              ><b-icon icon="x-circle"></b-icon
                            ></a>
                          </div>
                        </div>
                        <v-btn class="my-5 submit-btn-fill-color v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default" @click="addTransportEuroCost"
                          >Neu hinzufügen</v-btn
                        >
                      </div>
                      <v-radio class="mt-1 mb-5" value="pieces">
                        <template v-slot:label>
                          <div>Lieferspesen abhängig von der Stückzahl</div>
                        </template>
                      </v-radio>
                      <div v-if="form.transportCostOption === 'pieces'" class="mt-3">
                        <div class="row">
                          <div class="col-md-4">
                            <ValidationProvider
                              rules="priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                autocomplete="new-password"
                                :error-messages="errors[0]"
                                v-model="amount_grant_free_shipment"
                                label="Gratislieferung ab (€)"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                        </div>
                        <v-divider></v-divider>
                        <div
                          class="row mt-5"
                          v-for="(cost, i) in transportPieces"
                          :key="'ngf' + i"
                        >
                          <div class="col-md-4">
                            <ValidationProvider
                              rules="required|priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                type="number"
                                autocomplete="new-password"
                                :error-messages="errors[0]"
                                v-model="cost.quantity"
                                label="Produktanzahl"
                                min="0"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                          <div class="col-md-4">
                            <ValidationProvider
                              rules="required|priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                autocomplete="new-password"
                                v-model="cost.transport_cost"
                                :error-messages="errors[0]"
                                label="Lieferspesen (€)"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                          <div class="col-md-2 d-flex align-items-center">
                            <a v-if="i > 0" @click="removeTransportPiecesCost(i,cost)"
                              ><b-icon icon="x-circle"></b-icon
                            ></a>
                          </div>
                        </div>
                        <v-btn
                          class="my-5 submit-btn-fill-color v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                          @click="addTransportPiecesCost"
                          >Neu hinzufügen</v-btn
                        >
                      </div>
                    </v-radio-group>
                    <!-- </v-container> -->
                  </div>
                </div>

                <v-divider></v-divider>

                <div>
                  <v-checkbox
                    class="my-5"
                    v-model="isForeignDelEnabled"
                    label="Lieferungen ins Ausland möglich"
                  ></v-checkbox>
                  <div v-if="isForeignDelEnabled" class="row">
                    <div class="col-md-12">
                      <div>Lieferspesen-Optionen (nur eine auswählbar)</div>
                      <!-- <v-container fluid> -->
                      <v-radio-group v-model="form.fdTransportCostOption">
                        <v-radio value="free">
                          <template v-slot:label>
                            <div>versandkostenfrei</div>
                          </template>
                        </v-radio>
                        
                        <v-radio value="amount">
                          <template v-slot:label>
                            <div>Lieferspesen abhängig vom Gesamtbestellwert (€)</div>
                          </template>
                        </v-radio>
                       
                        <div v-if="form.fdTransportCostOption === 'amount'">
                          <div class="col-md-6">
                            <ValidationProvider
                              rules="priceInput"
                              v-slot="{ errors }"
                              :custom-messages="{
                                required: 'This is required',
                              }"
                            >
                              <v-text-field
                                autocomplete="new-password"
                                v-model="form.fd_free_deilvery_from"
                                :error-messages="errors[0]"
                                label="Gratislieferung ab (€)"
                                outlined
                                clearable
                              ></v-text-field>
                            </ValidationProvider>
                          </div>
                          <v-divider></v-divider>
                          <div
                            class="row mt-5"
                            v-for="(cost, i) in fdTransportEuro"
                            :key="'crf' + i"
                          >
                            <div class="col-md-5">
                              <ValidationProvider
                                rules="required|priceInput"
                                v-slot="{ errors }"
                                :custom-messages="{
                                  required: 'This is required',
                                }"
                              >
                                <v-text-field
                                  autocomplete="new-password"
                                  v-model="cost.order_cost"
                                  :error-messages="errors[0]"
                                  label="Bestellwert bis (€)"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="col-md-5">
                              <ValidationProvider
                                rules="required|priceInput"
                                v-slot="{ errors }"
                                :custom-messages="{
                                  required: 'This is required',
                                }"
                              >
                                <v-text-field
                                  autocomplete="new-password"
                                  v-model="cost.transport_cost"
                                  :error-messages="errors[0]"
                                  label="Lieferspesen (€)"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="col-md-2">
                              <a v-if="i > 0" @click="removeFdTransportEuroCost(i,cost)"
                                ><b-icon icon="x-circle"></b-icon
                              ></a>
                            </div>
                          </div>
                          <v-btn class="my-5 submit-btn-fill-color v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default" @click="addFdTransportEuroCost"
                            >Neu hinzufügen</v-btn
                          >
                        </div>
                        <v-radio class="mt-3 mb-5" value="pieces">
                          <template v-slot:label>
                            <div>Lieferspesen abhängig von der Stückzahl</div>
                          </template>
                        </v-radio>
                        <div v-if="form.fdTransportCostOption === 'pieces'" class="mt-1">
                          <div class="row">
                            <div class="col-md-4">
                              <ValidationProvider
                                rules="priceInput"
                                v-slot="{ errors }"
                                :custom-messages="{
                                  required: 'This is required',
                                }"
                              >
                                <v-text-field
                                  autocomplete="new-password"
                                  :error-messages="errors[0]"
                                  v-model="fd_amount_grant_free_shipment"
                                  label="Gratislieferung ab (€)"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                          <v-divider></v-divider>
                          <div
                            class="row mt-5"
                            v-for="(cost, i) in fdTransportPieces"
                            :key="'ngf' + i"
                          >
                            <div class="col-md-4">
                              <ValidationProvider
                                rules="required|priceInput"
                                v-slot="{ errors }"
                                :custom-messages="{
                                  required: 'This is required',
                                }"
                              >
                                <v-text-field
                                  type="number"
                                  autocomplete="new-password"
                                  :error-messages="errors[0]"
                                  v-model="cost.quantity"
                                  label="Produktanzahl"
                                  min="0"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="col-md-4">
                              <ValidationProvider
                                rules="required|priceInput"
                                v-slot="{ errors }"
                                :custom-messages="{
                                  required: 'This is required',
                                }"
                              >
                                <v-text-field
                                  autocomplete="new-password"
                                  v-model="cost.transport_cost"
                                  :error-messages="errors[0]"
                                  label="Lieferspesen (€)"
                                  outlined
                                  clearable
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="col-md-2 d-flex align-items-center">
                              <a v-if="i > 0" @click="removeFdTransportPiecesCost(i,cost)"
                                ><b-icon icon="x-circle"></b-icon
                              ></a>
                            </div>
                          </div>
                          <v-btn
                            class="my-5 submit-btn-fill-color v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                            @click="addFdTransportPiecesCost"
                            >Neu hinzufügen</v-btn
                          >
                        </div>
                      </v-radio-group>
                      <!-- </v-container> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <v-divider></v-divider>
                  <h3>Allgemeine Geschäftsbedingungen</h3>
                  <a v-if="pdfPreview" :href="pdfPreview" target="_blank"
                    >Vorschau anzeigen</a
                  >
                  <b-form-group id="fieldset-horizontal">
                    <vue-dropzone
                      name="companyLogo"
                      ref="uploadFile"
                      id="example-input-0 dropzone"
                      :useCustomSlot="true"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="(file) => uploadFile(file)"
                      @vdropzone-removed-file="handleRemoveFile"
                      aria-describedby="input-0-live-feedback"
                    >
                      <div class="dropzone dropzone-default" id="kt_dropzone_1">
                        <div class="dropzone-msg dz-message needsclick">
                          <h4>Bitte laden Sie eine Datei hoch</h4>
                          <h5>Datei hierhin ziehen oder klicken zum Upload</h5>
                          <p>
                            Erlaubte Formate: PDF
                            <br />Maximale Upload-Größe: 5MB
                          </p>
                        </div>
                      </div>
                    </vue-dropzone>
                  </b-form-group>
                </div>
                <div class="col-md-12"></div>
              </div>
              <div class="fo-row-btn text-right">
                <v-btn class="submit-btn-fill-outline" @click="goToBack">
                  Abbrechen
                </v-btn>
                <v-btn
                  type="submit"
                  :disabled="isDisabled"
                  ref="kt_form_submit_btn"
                  class="submit-btn-fill-color"
                >
                  {{ submitText }}
                </v-btn>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="setting" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import adminAPI from "@/api/admin";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import config from "@/config/app";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

import { extend } from "vee-validate";
Vue.use(Notifications);

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
}); 
// extend("priceInput", {
//   message: (field) => "enter valid value",
//   validate: (value) => {
//     if (value) {
//       var val = value.replace(",", ".");
//     }
//     if (val > 0) {
//       return true;
//     } else {
//       false;
//     }
//   },
// });

extend("digitValidation", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
export default {
  name: "GeneralSetting",
  props: {
    data: {
      type: String,
      required: true
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getGeneralSettings();
    }
  },
  data() {
    return {
      is_admin_dealer:this.data ? this.data: 0,
      dropzoneOptions: {
        url: config.API_URL + "add-terms",
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".pdf, .PDF",
        uploadMultiple: false,
        uploadprogress: false,
      },

      formError: false,
      userId: null,
      formData: [],
      types: [],
      transportEuro: [],
      transportPieces: [],
      fdTransportEuro: [],
      fdTransportPieces: [],
      btnDisable: false,
      submitText: "Speichern",
      amount_grant_free_shipment: "",
      fd_amount_grant_free_shipment: "",
      fileChanged: "0",
      pdfPreview: "",
      tempTax: "",
      brand_name: '',
      oldVatSettingChk: "",
      oldTax: "",
      isForeignDelEnabled: false,
      isPickupService: false,
      isParcelService: false,
      isAdded: false,
      form: {
        tax: "",
        minOrderValue: 0,
        transportCostOption: "free",
        fdTransportCostOption: "free",
        commission: "",
        file: "",
        vatSettingChk: false,
        free_deilvery_from: "",
        fd_free_deilvery_from: "",
        //status: false,
      },
      transportCostInformations: [
        {
          totalOrderAmount: "",
          transportCost: "",
        },
      ],
      fdTransportPiecesCopy:[],
      fdTransportEuroCopy:[],
      transportEuroCopy: [],
      transportPiecesCopy: [],
      deleteCost:[],
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  watch: {
    "form.vatSettingChk": function (value) {
      if (value) {
        this.form.tax = 0;
      } else {
        this.form.tax = this.tempTax;
      }
    },
  },
  methods: {
    handleRemoveFile() {
      this.form.file = null;
      this.fileChanged = "1";
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.fileChanged = "1";
          this.form.file = file;
        }
      }, 1000);
    },
    addTransportEuroCost() {
      this.transportEuro.push({
        id:"",
        order_cost: "",
        transport_cost: "",
      });
    },
    removeTransportEuroCost(i,cost) {
    if(cost.id && cost.transport_cost){
      this.deleteCost.push(cost);
    }
      this.transportEuro.splice(i, 1);
    },
    addTransportPiecesCost() {
      this.transportPieces.push({
        id:"",
        quantity: "",
        transport_cost: "",
      });
    },
    removeTransportPiecesCost(i,cost) {
    if(cost.id && cost.transport_cost){
      this.deleteCost.push(cost);
    }
      this.transportPieces.splice(i, 1);
    },

    addFdTransportEuroCost() {
      this.fdTransportEuro.push({
        id:"",
        order_cost: "",
        transport_cost: "",
      });
    },
    removeFdTransportEuroCost(i,cost) {
    if(cost.id && cost.transport_cost){
      this.deleteCost.push(cost);
    }
      this.fdTransportEuro.splice(i, 1);
    },
    addFdTransportPiecesCost() {
      this.fdTransportPieces.push({
        id:"",
        quantity: "",
        transport_cost: "",
      });
    },
    removeFdTransportPiecesCost(i,cost) {
    if(cost.id && cost.transport_cost){
      this.deleteCost.push(cost);
    }
      this.fdTransportPieces.splice(i, 1);
    },

    goToBack() {
      if (this.is_admin_dealer) {
        this.$router.push({ name: "manage-producers" });
      } else {
        this.$router.push({ name: "producers" });
      }
    },
    getGeneralSettings() {
      adminAPI
        .getGeneralSettings({ id: this.$router.currentRoute.params.id, is_admin_dealer:this.is_admin_dealer })
        .then((response) => {
          // console.log(response);
          if (response.status == "success") {
            if (response.data.producer_details) {
              this.brand_name = response.data.producer_details.brand_name
              // this.form.tax = response.data.tax;
              this.tempTax = response.data.tax;
              this.form.minOrderValue = response.data.min_order_value;
              this.form.commission = response.data.producer_details.commission;
              this.isForeignDelEnabled =
                response.data.is_abroad_shipping === "1" ? true : false;
              this.isParcelService =
                response.data.is_parcel_service === "1" ? true : false;
              this.isPickupService =
                response.data.is_pickup_service === "1" ? true : false;
              this.form.transportCostOption = response.data.transport_cost_option;
              this.form.fdTransportCostOption =
                response.data.abroad_transport_cost_option;
              let costType = "";
              let fdCostType = "";
              this.form.vatSettingChk =
                response.data.is_vat_zero_to_all_products === "1" ? true : false;
              this.oldVatSettingChk = response.data.is_vat_zero_to_all_products;
              if (response.data.producer_details) {
                if (response.data.producer_details.general_transport_cost.length) {
                  response.data.producer_details.general_transport_cost.forEach(
                    (item) => {
                      if (item.type === "Order Amount") {
                        costType = "amount";
                        if (item.status == '1') {
                          this.transportEuro.push({
                            id:item.id,
                            order_cost: item.value,
                            transport_cost: item.cost,
                          });
                          this.transportEuroCopy.push({
                            id: item.id,
                            order_cost: item.value,
                            transport_cost: item.cost,
                          });
                        }
                      } else if (item.type === "Pieces") {
                        costType = "pieces";
                        if (item.status == '1') {
                          this.transportPieces.push({
                            id:item.id,
                            quantity: item.value,
                            transport_cost: item.cost,
                          });
                          this.transportPiecesCopy.push({
                            id: item.id,
                            quantity: item.value,
                            transport_cost: item.cost,
                          });
                        }
                      }
                    }
                  );
                  this.amount_grant_free_shipment =
                    response.data.amount_grant_free_shipment;
                  this.form.free_deilvery_from =
                    response.data.transportation_cost_free_from;
                  if (costType == "pieces" && !this.transportPieces.length) {
                    this.transportPieces.push({
                      id:"",
                      quantity: "",
                      transport_cost: "",
                    });
                  }
                  if (costType == "amount" && !this.transportEuro.length) {
                    this.transportEuro.push({
                      id:"",
                      order_cost: "",
                      transport_cost: "",
                    });
                  }
                } else {
                  this.form.transportCostOption = "free";
                  this.transportEuro.push({
                    id:"",
                    order_cost: "",
                    transport_cost: "",
                  });
                  this.transportPieces.push({
                    id:"",
                    quantity: "",
                    transport_cost: "",
                  });
                }

                if (
                  response.data.producer_details.abroad_shipping_transport_cost.length
                ) {
                  response.data.producer_details.abroad_shipping_transport_cost.forEach(
                    (item) => {
                      if (item.type === "Order Amount") {
                        fdCostType = "amount"
                        if (item.status == '1') {
                          this.fdTransportEuro.push({
                            id:item.id,
                            order_cost: item.value,
                            transport_cost: item.cost,
                          });
                          this.fdTransportEuroCopy.push({
                            id: item.id,
                            order_cost: item.value,
                            transport_cost: item.cost,
                          });
                        }
                      } else if (item.type === "Pieces") {
                        fdCostType = "pieces"
                        if (item.status == '1') {
                          this.fdTransportPieces.push({
                            id:item.id,
                            quantity: item.value,
                            transport_cost: item.cost,
                          });
                          this.fdTransportPiecesCopy.push({
                            id: item.id,
                            quantity: item.value,
                            transport_cost: item.cost,
                          });
                        }
                        
                      }
                    });
                  this.fd_amount_grant_free_shipment = response.data
                    .abroad_amount_grant_free_shipment
                    ? response.data.abroad_amount_grant_free_shipment
                    : "";
                  this.form.fd_free_deilvery_from = response.data
                    .abroad_transportation_cost_free_from
                    ? response.data.abroad_transportation_cost_free_from
                    : "";
                  // console.log("fdd ", fdCostType);
                  if (fdCostType == "pieces" && !this.fdTransportPieces.length) {
                    this.fdTransportPieces.push({
                      id:"",
                      quantity: "",
                      transport_cost: "",
                    });
                  }
                  if (fdCostType == "amount" && !this.fdTransportEuro.length) {
                    this.fdTransportEuro.push({
                      id:"",
                      order_cost: "",
                      transport_cost: "",
                    });
                  }
                } else {
                  this.form.fdTransportCostOption = "free";
                  this.fdTransportEuro.push({
                    id:"",
                    order_cost: "",
                    transport_cost: "",
                  });
                  this.fdTransportPieces.push({
                    id:"",
                    quantity: "",
                    transport_cost: "",
                  });
                }
              }
              if (response.data.term_and_conditions_pdf_path) {
                this.pdfPreview = response.data.term_and_conditions_pdf_path;
                var file = {
                  size: 12345,
                  name: response.data.term_and_conditions_pdf_name,
                  type: "application/pdf",
                };
                this.$refs.uploadFile.manuallyAddFile(
                  file,
                  response.data.term_and_conditions_pdf_path
                );
              }
            } else {
              this.form.transportCostOption = "free";
              this.transportEuro.push({
                id:"",
                order_cost: "",
                transport_cost: "",
              });
              this.transportPieces.push({
                id:"",
                quantity: "",
                transport_cost: "",
              });
              this.fdTransportEuro.push({
                id:"",
                order_cost: "",
                transport_cost: "",
              });
              this.fdTransportPieces.push({
                id:"",
                quantity: "",
                transport_cost: "",
              });
            }
            this.getAdminGeneralSettings();
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            //this.form.status = response.data[0].is_allowed == 1 ? true : 0;
          } else {
            this.form.transportCostOption = "free";
            this.transportEuro.push({
              id:"",
              order_cost: "",
              transport_cost: "",
            });
            this.transportPieces.push({
              id:"",
              quantity: "",
              transport_cost: "",
            });
            this.fdTransportEuro.push({
              id:"",
              order_cost: "",
              transport_cost: "",
            });
            this.fdTransportPieces.push({
              id:"",
              quantity: "",
              transport_cost: "",
            });
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "setting",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.btnDisable = false;
          this.submitText = "Speichern";
          this.$notify({
            group: "setting",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    getAdminGeneralSettings() {
      adminAPI
        .getGeneralSetting({ id: this.currentUser.id, is_admin_dealer:this.is_admin_dealer })
        .then((response) => {
          if (response.status == "success") {
            if (this.form.vatSettingChk) {
              this.form.tax = 0;
              this.tempTax = response.data.tax;
            } else {
              if (this.tempTax) {
                this.form.tax = this.tempTax;
              } else {
                this.tempTax = response.data.tax;
                this.form.tax = response.data.tax;
              }
            }
            if (!this.form.commission) {
              this.form.commission = response.data.dealer_commission;
            }

            //this.form.status = response.data[0].is_allowed == 1 ? true : 0;
          } else {
            this.$notify({
              group: "setting",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.btnDisable = false;
          this.submitText = "Speichern";
          this.$notify({
            group: "setting",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    onSubmit() {
      if (this.isParcelService == false && this.isPickupService == false) {
        setTimeout(() => {
            this.isAdded = false;
          }, 5000);
          this.isAdded = true;
      }
      this.$refs.newSettingForm.validate().then((success) => {
        if (success && (this.isParcelService != false || this.isPickupService != false)) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";
          let fd = new FormData();
          fd.append("is_admin_dealer", this.is_admin_dealer);
          fd.append("producer_id", this.$router.currentRoute.params.id);
          fd.append("tax", this.form.tax);
          fd.append("min_order_value", this.form.minOrderValue);
          fd.append("commission", this.form.commission);
          fd.append("transport_cost_option", this.form.transportCostOption);
          fd.append("abroad_transport_cost_option", this.form.fdTransportCostOption);
          fd.append("is_shipping_abroad", this.isForeignDelEnabled ? "1" : "0");
          fd.append("is_vat_zero_to_all_products", this.form.vatSettingChk ? "1" : "0");
          fd.append("old_is_vat_zero_to_all_products", this.oldVatSettingChk);
          fd.append("is_parcel_service", this.isParcelService ? 1 : 0);
          fd.append("is_pickup_service", this.isPickupService ? 1 : 0);
          if (this.form.transportCostOption === "amount") {
            fd.append("transport_costs_array", JSON.stringify(this.transportEuro));
            fd.append("transportation_cost_free_from", this.form.free_deilvery_from);
          }
          if (this.form.transportCostOption === "pieces") {
            fd.append("transport_costs_array", JSON.stringify(this.transportPieces));
            fd.append("amount_grant_free_shipment", this.amount_grant_free_shipment);
          }

          if (this.form.fdTransportCostOption === "amount") {
            fd.append(
              "abroad_transport_costs_array",
              JSON.stringify(this.fdTransportEuro)
            );
            fd.append(
              "abroad_transportation_cost_free_from",
              this.form.fd_free_deilvery_from
            );
          }
          if (this.form.fdTransportCostOption === "pieces") {
            fd.append(
              "abroad_transport_costs_array",
              JSON.stringify(this.fdTransportPieces)
            );
            fd.append(
              "abroad_amount_grant_free_shipment",
              this.fd_amount_grant_free_shipment
            );
          }
          fd.append("file_changed", this.fileChanged);
          fd.append("terms_file", this.form.file);

          let coastStatus = [];
          if (this.form.fdTransportCostOption === "amount") {
            coastStatus.push(this.arraysAreEqual(this.fdTransportEuro, this.fdTransportEuroCopy));
            
          }

          if (this.form.fdTransportCostOption === "pieces") {
            coastStatus.push(this.arraysAreEqual(this.fdTransportPieces, this.fdTransportPiecesCopy));
           
          }

          if (this.form.transportCostOption === "amount") {
            coastStatus.push(this.arraysAreEqual(this.transportEuro, this.transportEuroCopy));
          }

          if (this.form.transportCostOption === "pieces") {
            coastStatus.push(this.arraysAreEqual(this.transportPieces, this.transportPiecesCopy));
          }
          console.log('4',coastStatus);
          if(coastStatus[0]== 'New' && coastStatus[1]== 'New'){
            this.showNotification('New');
          }else if(coastStatus[0]== 'Update' && coastStatus[1]== 'Update'){
            this.showNotification('Update');
          }else if(coastStatus[0]== 'New' && coastStatus[1]== 'Update'){
            this.showNotification('New');
            this.showNotification('Update');
          }else if(coastStatus[0]== 'Update' && coastStatus[1]== 'New'){
            this.showNotification('Update');
            this.showNotification('New');
          }else if(coastStatus[0]== 'Equal' && coastStatus[1]== 'New'){
            this.showNotification('New');
          }else if(coastStatus[0]== 'New' && coastStatus[1]== 'Equal'){
            this.showNotification('New');
          }else if(coastStatus[0]== 'Equal' && coastStatus[1]== 'Update'){
            this.showNotification('Update');
          }else if(coastStatus[0]== 'Update' && coastStatus[1]== 'Equal'){
            this.showNotification('Update');
          }

          this.deleteCost.forEach((item, index) => {
            fd.append(`deleteCost[${index}][id]`, item.id);
            fd.append(`deleteCost[${index}][cost]`, item.transport_cost);
            if(item.order_cost){
              fd.append(`deleteCost[${index}][value]`, item.order_cost);
            }
            if(item.quantity){
              fd.append(`deleteCost[${index}][value]`, item.quantity);
            }

         });

          //fd.append("status", this.form.status ? "1" : "0");

          setTimeout(() => {
            adminAPI
              .updateGeneralSetting(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Speichern";
                  this.btnDisable = false;
                  this.$notify({
                    group: "setting",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  transportCostInformations: [
                    {
                      totalOrderAmount: "",
                      transportCost: "",
                    },
                  ],
                    this.formData= [];
                    this.types= [];
                    this.transportEuro= [];
                    this.transportPieces= [];
                    this.fdTransportEuro= [];
                    this.fdTransportPieces= [];
                    this.fdTransportPiecesCopy= [];
                    this.fdTransportEuroCopy= [];
                    this.transportEuroCopy= [];
                    this.transportPiecesCopy= [];
                    this.getGeneralSettings();
                  // window.location.reload();
                  //comented code by rina on 06/04/2023
                  // setTimeout(() => {
                  //   this.$router.push({ name: "producers" });
                  // }, 3000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.fileChanged = "0";
                  this.$notify({
                    group: "setting",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "setting",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "setting",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
    showNotification(status) {
      let text = "WARNUNG: ";
      if (status == 'New') {
        text += "diese neue Zeile wird auch automatisch für alle Produkte mit spezifischen Versandkosten übernommen.";
      } else if (status == 'Update') {
        text += "der geänderte Wert wird NICHT automatisch für alle Produkte mit spezifischen Versandkosten übernommen.";
      }

      this.$notify({
        group: "setting",
        type: "error",
        position: "bottom right",
        text: text,
        duration: 5000,
      });
    },
    arraysAreEqual(arr1, arr2) {
      if (arr1.length == arr2.length) {
        if(arr1.some(obj => obj.id == "" && obj.quantity != "" && obj.transport_cost != "")){
          return "New";
        }else{
        if(JSON.stringify(arr1) === JSON.stringify(arr2)){
          return "Equal";
        }else{
          return "Update"; 
        }
          
        }
      }else if(arr1.length < arr2.length) {
        return "Equal";
      }else if(arr1.length > arr2.length) {
        return "New";
      }
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
